import utils from "@/components/declarations/validators/utils";

function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function validatePhone(phone) {
  const re = /^\+?\d{8,11}(,\+?\d{8,11})*$/;
  return re.test(String(phone).toLowerCase());
}

export default {
  isValid(self, isDraft) {
    const errors = {
      atLeastOne: false,
      name: false,
      phone: false,
      email: false,
    };
    self.setErrors(errors);
    let text = "";

    if (!self.name.length) {
      errors.atLeastOne = true;
      errors.name = true;
      text += "Prosimy o podanie imienia i nazwiska osoby wypełniającej formularz deklaracji <br/>";
    }

    if (!!self.email && self.email.length && !validateEmail(self.email)) {
      errors.atLeastOne = true;
      errors.email = true;
      text += "Podany adres email jest nieprawidłowy <br/>";
    }

    if (!!self.phone && self.phone.length && !validatePhone(self.phone)) {
      errors.atLeastOne = true;
      errors.phone = true;
      text += "Podany numer telefonu jest nieprawidłowy <br/>";
    }

    if ((typeof(isDraft) != 'undefined') && (!isDraft) && (!self.hasStatement)) {
      errors.atLeastOne = true;
      errors.hasStatement = true;
      text += "Aby złożyć deklarację, zaznacz pole z oświadczeniem. <br/>";
    }

    if (errors.atLeastOne) {
      utils.showMessage(self, text);
    }

    return errors;
  }
}
